const footerCn = {
  company: '乡村集市',
  description: '孟加拉国最大的在线市场。每天找到您需要的一切。',
  links: {
    company: '公司',
    business: '商业',
    support: '支持',
    about: '关于我们',
    career: '职业',
    contact: '联系',
    help: '帮助',
    becomeSeller: '成为卖家',
    businessAccount: '商业账户',
    marketplacePolicy: '市场政策',
    deliveryPolicy: '配送政策',
    returnPolicy: '退货政策',
    privacyPolicy: '隐私政策',
  },
  contact: {
    heading: '联系',
    address: '房屋#123，道路#45，巴纳尼，达卡-1213',
  },
  copyright: (year) => `© ${year} 乡村集市。保留所有权利。`,
};

export default footerCn;
